export const AUTH_TOKEN_STORAGE_KEY = "stoop_token";

export const ADMIN_ROLES = new Set(["org_owner", "brokerage_admin"]);

export const INVITE_RECOVERY_HEADLINES: Record<string, string> = {
  revoked: "This invitation was revoked.",
  expired: "This invitation has expired.",
  already_accepted: "This invitation was already accepted.",
};
